// import images from all-images/blog-img directory
import img01 from "../all-images/blog-img/blog-1.jpg";
import img02 from "../all-images/blog-img/blog-2.jpg";
import img03 from "../all-images/blog-img/blog-3.jpg";

const blogData = [
  {
    id: 1,
    title: "Unleash the Explorer Within: A Guide to Off-Road Adventures in Kenya",
    author: "Linet",
    date: "22 Sep, 2023",
    time: "9pm",
    imgUrl: img01,
    description:
      " Are you an adventure enthusiast seeking the thrill of off-road exploration in Kenya? Look no further! Our comprehensive guide will take you on a journey through the rugged, untamed landscapes of Kenya. From the magnificent Great Rift Valley to the awe-inspiring Chyulu Hills, we will lead you to the most thrilling off-road destinations. Dive into the world of off-road exploration, learn the secrets of conquering challenging terrains, and uncover the hidden gems of Kenya. Whether you're a seasoned off-roader or a first-time explorer, this blog is your gateway to a world of adrenaline-pumping adventures.",
    quote:
      "Voluptua dolore takimata dolor sadipscing nonumy consetetur et. Stet sed dolores dolores dolores dolores eos.",
  },

  {
    id: 2,
    title: "Kenya's Hidden Treasures: Discovering Pristine Lakes, Enchanted Forests, and More",
    author: "Sakwa",
    date: "01 Oct, 2023",
    time: "9pm",
    imgUrl: img02,
    description:
      " Escape the well-trodden paths and embark on a journey to uncover Kenya's best-kept secrets. From secluded, crystal-clear lakes nestled in remote valleys to the captivating forests teeming with diverse flora and fauna, Kenya offers a wealth of untouched natural beauty. In this blog, we unveil the hidden gems of Kenya that often go unnoticed by the masses. Prepare to be enchanted by the pristine landscapes, cultural richness, and serene surroundings that await the intrepid traveler. Our detailed exploration will guide you to Kenya's lesser-known wonders and inspire you to experience the true essence of the country.",
    quote:
      "Voluptua dolore takimata dolor sadipscing nonumy consetetur et. Stet sed dolores dolores dolores dolores eos.",
  },

  {
    id: 3,
    title: "Road-Ready and Reliable: A Comprehensive Guide to Maintaining Your Rental Car",
    author: "Eugene",
    date: "12 Oct, 2023",
    time: "9pm",
    imgUrl: img03,
    description:
      " Your rental vehicle is your key to a successful and worry-free adventure in Kenya. To ensure it remains road-ready and reliable, we've crafted a comprehensive guide to car maintenance. From tire care and regular oil changes to the importance of checking fluid levels and inspecting brakes, this blog covers all the essentials. We understand the value of a trouble-free journey, and with our tips, you'll be equipped to keep your rental vehicle in optimal condition. Learn how a little maintenance can go a long way in guaranteeing a smooth and memorable trip.",
    quote:
      "Voluptua dolore takimata dolor sadipscing nonumy consetetur et. Stet sed dolores dolores dolores dolores eos.",
  },
];

export default blogData;
